import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Consultant } from 'src/app/models/consultant.model';

@Component({
  selector: 'ct-boarding-consultant',
  templateUrl: './boarding-consultant.component.html',
  styleUrls: ['./boarding-consultant.component.scss']
})
export class BoardingConsultantComponent implements OnInit {

  public consultant$: Observable<Consultant>;

  constructor(
    private store: Store,
    public authenticationService: AuthenticationService,
    public translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
  }

}
